const BOT_URL = "https://t.me/StreetP_bot";

export function TelegramOnlyStub() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100dvh",
        padding: 24,
        textAlign: "center",
        gap: 16,
        background: "var(--bg)",
        color: "var(--fg)",
      }}
    >
      <h1 className="h1" style={{ margin: 0 }}>StreetPong</h1>
      <p className="body" style={{ color: "var(--fg2)", maxWidth: 360, margin: 0 }}>
        Приложение работает только внутри Telegram. Открой бота — там турниры, рейтинг, карта спотов.
      </p>
      <a
        href={BOT_URL}
        target="_blank"
        rel="noreferrer"
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "12px 24px",
          borderRadius: 999,
          background: "var(--brand-orange, #FF5A1F)",
          color: "#fff",
          fontFamily: "var(--font-body)",
          fontWeight: 600,
          fontSize: 16,
          textDecoration: "none",
          marginTop: 8,
        }}
      >
        Открыть в Telegram
      </a>
    </div>
  );
}
